import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import getFallBackImage from '../../../../helpers/getFallbackImage';

const PVSubCategoryTile = ({ subcategory, categoryName, parentCategoryName, parentCategory }) => {
    return (
        <div className="product-item style1 width-33 padding-0 col-md-3 col-sm-6 col-xs-6 equal-elem">
            <div className="product-outer3">
                <div className="product-inner3">
                    <div className="product-thumb">
                        <Link to={`${subcategory.UrlToUse}{parentCategory}/${categoryName}/${subcategory.Name}`}>
                            {subcategory.ThumbnailImage ? (
                                <img
                                    width={160} height={160}
                                    src={subcategory.ThumbnailImage}
                                    alt={subcategory.DisplayName}
                                    onError={(e) =>
                                        getFallBackImage(
                                            e,
                                            '/WebSupport/PV_React/WebStore/category-thumbs/imageNotAvailable.jpg'
                                        )
                                    }
                                />
                            ) : (
                                ''
                            )}
                        </Link>
                    </div>
                    <div className="product-name pv-subcategory-product-name">
                        <Link to={`${subcategory.UrlToUse}${parentCategoryName}/${categoryName}/${subcategory.Name}`}>
                            {subcategory.DisplayName}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

PVSubCategoryTile.propTypes = {
    subcategory: PropTypes.shape({
        Name: PropTypes.string,
        ThumbnailImage: PropTypes.string,
        DisplayName: PropTypes.string,
    }).isRequired,
    categoryName: PropTypes.string.isRequired,
};

export default PVSubCategoryTile;
